import { useEffect, useState, useRef } from 'react'
import { Modal, message, Form, DatePicker, InputNumber, Input, Button } from 'antd'
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy, getImgUrlById, fetchSvg } from '../../util';
import { StorageModule } from "../../modules/storage";
import type { DatePickerProps, UploadProps } from 'antd';
import user_default from '../../static/image/user_default.png'
import InitUpload from '../../components/upload';
import ImageOverlays from '../../components/ImageOverlays/index';
import ModelScreen from './modelScreen';

import Users from './users'
import { getUserList } from '../../api/user'

import moment from "moment";

interface Props {
    visible?: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    saveNode?: (i: any, txt: any,) => void;
}
const { TextArea } = Input;

const TaskTagPop = (props: Props) => {
    const [userInfo, setUserInfo] = useState<any>();
    const [isDeletExecutor, setIsDeletExecutor] = useState<boolean>(false);
    const [imgId, setImgId] = useState<string>('');
    const { store, dispatch } = useStore();
    const [form] = Form.useForm();
    const [finishTime, setFinishTime] = useState<any>('');
    //下一步
    const [imgNotesTagNextStep, setImgNotesTagNextStep] = useState<boolean>(false);
    const [usersVisible, setUsersVisible] = useState<boolean>(false);
    const [executorInfo, setExecutorInfo] = useState<any>({});
    const today = moment(); // 当天日期
    const [userList, setUserList] = useState<any>([]);
    const [ownerId, setOwnerId] = useState<string>('');
    const [taskInfo, setTaskInfo] = useState<any>({});
    const [markDown, setMarkDown] = useState<any>('');
    //记录标注的数据，最后保存的更新被移动的状态
    const [imageOverlaysMarkData, setImageOverlaysMarkData] = useState<any>();
    //新建的便签直接附带格式用的
    const [title, setTitle] = useState<any>('');
    useEffect(() => {
        try {
            if (store.taskVisible) {
                setUserInfo(StorageModule.getUser().user);
                if (store.memoOperation.isAdd) {
                    dealImageTag(null, true)
                } else {
                    dealImageTag()
                }
            } else {
                setTimeout(() => {
                    reset()
                }, 500);

            }
        } catch (e) {
            console.log(e)
        }
    }, [store.taskVisible])
    useEffect(() => {
        console.log('store.selectTagMeta', store.selectTagMeta, store.myEditMemo)
        if (store.memoOperation.isAdd && store.myEditMemo?.data.hasOwnProperty('tagMetas') && (store.selectTagMeta?.mimeType == store.myEditMemo?.data?.tagMetas[0]?.mimeType)) {
            dealImageTag(null, true)
        } else {
            dealImageTag(null, false)
        }
    }, [store.selectTagMeta,])

    const reset = () => {
        console.log('重置表单')
        setIsDeletExecutor(false)
        setImgNotesTagNextStep(false)
        setMarkDown('')
        setImgId('')
        //清除状态
        form.setFieldsValue({
            manHour: null,
            finishTime: null,
            executorId: null,
            release: null,
            imagePath: null,
            title: ''
        });
        form.resetFields();
        setTitle('')
        setImgId('')
        dispatch({
            type: 'SET_IMGNOTESTAG',
            data: []
        });
        dispatch({
            type: 'SET_WATCHISMARK',
            data: true
        });
    }
    const dealImageTag = (params?: any, isMemoAdd?: any) => {
        try {
            if (!params) {
                params = store.selectTagMeta
            }
            setImgId('')
            // let TaskTag: any =store.myEditMemo.tagMetas?.filter((i: any) => i.notation === 'TaskTag')
            // let ImageTag: any =store.myEditMemo.tagMetas?.filter((i: any) => i.notation === 'ImageTag')
            // let ImgNotesTag: any =store.myEditMemo.tagMetas?.filter((i: any) => i.notation === 'ImgNotesTag')
            let _notation: any = store.myEditMemo?.data?.tagMetas?.filter((i: any) => i.notation === params.notation)
            console.log('_taskType', params,)
            console.log('_notation', _notation)
            console.log('_memoInfo', store.myEditMemo)
            console.log('_selectTagMeta', store.selectTagMeta)

            if (_notation && _notation.length > 0) {
                if (params.notation === 'TaskTag') {
                    let info: any = _notation.filter((i: any) => i.name === params.name)
                    console.log(info)
                    if (info.length > 0) {
                        setTaskInfo({ ...info[0] })
                        form.setFieldsValue({
                            manHour: info[0]?.instance.manHour || null,
                            finishTime: info[0].instance ? moment(info[0].finishTime) : null,
                            executorId: info[0].instance?.executorId || null,
                        });
                        setFinishTime(info[0] ? moment(info[0].finishTime) : null)
                        setExecutorInfo(info[0].instance.executorUser)
                    } else {
                        setExecutorInfo({})
                    }
                } else if (params.notation === 'ImageTag') {
                    setTaskInfo({ ..._notation[0], title: store.myEditMemo.data.content })
                    form.setFieldsValue({
                        title: store.myEditMemo.data.content || null,
                        imagePath: _notation[0].instance.imagePath || null,
                    });
                    setImgId(_notation[0].instance.imagePath)
                    setImgNotesTagNextStep(false)
                    console.log('没走这个么？', params.notation)
                } else if (params.notation === 'ImgNotesTag') {
                    console.log('走这个么？ImgNotesTag', _notation[0].instance.imagePath)
                    if (_notation[0].instance.imagePath && _notation[0].instance.imagePath != '' && !isMemoAdd) {
                        setImgNotesTagNextStep(false)
                    } else {
                        setImgNotesTagNextStep(true)
                    }
                    setTaskInfo({ ..._notation[0], title: store.myEditMemo.data.content })

                    form.setFieldsValue({
                        title: store.myEditMemo.data.content || null,
                        imagePath: _notation[0].instance.imagePath || null,
                    });
                    setImgId(_notation[0].instance.imagePath)
                    let _annotation: any = []
                    _notation[0].instance.annotation?.map((i: any, index: any) => {
                        _annotation.push({
                            id: index,
                            "x": i.x,
                            "y": i.y,
                            "w": i.w,
                            "h": i.h,
                            isCompile: false,
                            subject: i.description,
                            "description": i.description,
                            isSelect: false,
                            isCheck: false,
                            //ownerId是便签所有者id。
                            ownerId: store.myEditMemo?.data?.ownerId
                        })
                    })
                    dispatch({
                        type: 'SET_IMGNOTESTAG',
                        data: _annotation
                    });
                }

            } else {
                console.log('!_notation', params.notation, store.selectTagMeta, store.myEditMemo.data)
                if (params.notation === 'TaskTag') {
                    setExecutorInfo({})
                } else if (params.notation === 'ImageTag') {
                    //是否从图片标注切换回来
                    let _isImgNotesTag = store.myEditMemo?.data?.tagMetas?.find((i: any) => i.notation === "ImgNotesTag")
                    console.log('_isImgNotesTag1', store.myEditMemo.data, _isImgNotesTag)
                    form.setFieldsValue({
                        title: store.myEditMemo.data.content || null,
                        imagePath: _isImgNotesTag?.instance?.imagePath || null,
                    });
                    if (_isImgNotesTag) {
                        setImgId(_isImgNotesTag.instance.imagePath)

                    }
                    setTaskInfo({ title: store.myEditMemo.data.content })
                    //兼容网页格式
                    if (!_isImgNotesTag && store.myEditMemo.data.mimeType == "text/webpage") {
                        let _WebPageTag = store.myEditMemo?.data?.tagMetas?.find((i: any) => i.mimeType == "text/webpage")
                        console.log('兼容网页格式', _WebPageTag)
                        form.setFieldsValue({
                            title: _WebPageTag.instance.titleImageAltText || store.myEditMemo.data.content,
                            imagePath: _WebPageTag.instance.titleImageFileUrl || null,
                        });
                        setImgId(_WebPageTag.instance.titleImageFileUrl)
                        setTitle(_WebPageTag.instance.titleImageAltText)
                        setTaskInfo({ title: _WebPageTag.instance.titleImageAltText || store.myEditMemo.data.content })
                    }

                } else if (params.notation === 'ImgNotesTag') {
                    let _isImgNotesTag = store.myEditMemo?.data?.tagMetas?.find((i: any) => i.notation === "ImageTag")
                    if (_isImgNotesTag) {
                        setImgId(_isImgNotesTag.instance.imagePath)
                    }
                    form.setFieldsValue({
                        title: store.myEditMemo.data.content || null,
                        imagePath: _isImgNotesTag?.instance?.imagePath || null,
                    });
                    setTaskInfo({ title: store.myEditMemo.data.content })
                    setImgNotesTagNextStep(true)
                    if (!_isImgNotesTag && store.myEditMemo.data.mimeType == "text/webpage") {
                        let _WebPageTag = store.myEditMemo?.data?.tagMetas?.find((i: any) => i.mimeType == "text/webpage")
                        form.setFieldsValue({
                            title: _WebPageTag.instance.titleImageAltText || store.myEditMemo.data.content,
                            imagePath: _WebPageTag.instance.titleImageFileUrl || null,
                        });
                        setImgId(_WebPageTag.instance.titleImageFileUrl)
                        setTitle(_WebPageTag.instance.titleImageAltText)
                        setTaskInfo({ title: _WebPageTag.instance.titleImageAltText || store.myEditMemo.data.content })
                    }
                }
            }
            return
        } catch (e) {
            console.log('dealImageTag', e)
        }
    }
    useEffect(() => {
        if (usersVisible) {
            onGetUserList()
        } else {
        }
    }, [usersVisible])
    useEffect(() => {
        if (store.memoOperation.isAdd && imgId && store.myEditMemo?.data?.tagMetas[0].instance?.imagePath != imgId) {
            console.log('imgId触发了')
            let tagMetas = {
                ...store.myEditMemo?.data?.tagMetas[0],
                instance: {
                    ...store.myEditMemo?.data?.tagMetas[0].instance,
                    imagePath: imgId
                }
            }
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { ...store.myEditMemo, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }] } }
            });
        }
    }, [imgId, store.myEditMemo])
    useEffect(() => {
        console.log('form.getFieldsValue().titlestore.myEditMemo', store.myEditMemo)
        if (store.memoOperation.isAdd && title && store.myEditMemo?.data?.tagMetas[0].instance?.content != title) {
            let tagMetas = {
                ...store.myEditMemo?.data?.tagMetas[0],
                instance: {
                    ...store.myEditMemo?.data?.tagMetas[0].instance,
                    content: title
                }
            }
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { ...store.myEditMemo, content: title, data: { ...store.myEditMemo.data, content: title, tagMetas: [{ ...tagMetas }] } }
            });
        }
    }, [title, store.myEditMemo])
    useEffect(() => {
        console.log('store.ImgNotesTag', title, store.ImgNotesTag)
        if (store.memoOperation.isAdd && title && store.ImgNotesTag.length > 0) {
            let _annotation: any = []
            store.ImgNotesTag.map((i: any, index: any) => {
                _annotation.push({
                    "x": imageOverlaysMarkData[index]?.coor[0][0],
                    "y": imageOverlaysMarkData[index]?.coor[0][1],
                    "w": imageOverlaysMarkData[index]?.coor[1][0],
                    "h": imageOverlaysMarkData[index]?.coor[1][1],
                    "description": i.description,
                })
            })
            let tagMetas = {
                ...store.myEditMemo?.data?.tagMetas[0],
                instance: {
                    ...store.myEditMemo?.data?.tagMetas[0].instance,
                    annotation: _annotation
                }
            }
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { ...store.myEditMemo, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }] } }
            });
        }
    }, [store.ImgNotesTag])
    const onGetUserList = async () => {

        try {
            let res: any = await getUserList({ enabled: true })
            if (res.ok) {
                const list = res.data.list.filter((item: any) => item.id !== ownerId)
                console.log('getDetail===', list, ownerId)
                setUserList(res.data.list)
            }
        } catch { }
    }
    /**
        * 新建/修改任务计划
        * @returns 
        */
    const addTask = async () => {
        try {

            let memo: any = store.memoInfo
            let name: any
            let _userInfo: any = StorageModule.getUser().user

            console.log(store.myEditMemo, store.memoInfo)
            let params: any = {
                memoId: memo.data.id,
                name: store.selectTagMeta.name,
            }

            console.log(form.getFieldsValue().executorId)
            if (store.selectTagMeta.name == '任务计划' || store.selectTagMeta.name == '开始执行' || store.selectTagMeta.name == '任务完成') {
                if (store.selectTagMeta.name !== '任务计划') {
                    //值为当前操作人
                    params.executorId = userInfo?.id
                } else if (form.getFieldsValue().executorId != null) {
                    params.executorId = form.getFieldsValue().executorId
                }
                params.finishTime = (finishTime != '') ? moment(finishTime).format('YYYY-MM-DDT23:59:59') : form.getFieldsValue().finishTime.format('YYYY-MM-DDT23:59:59')
                params.manHour = form.getFieldsValue().manHour
                let res: any = await apis.putMemoNotation(memo.data.id, store.selectTagMeta.notation, params)
                if (res.ok) {
                    dispatch({
                        type: 'SET_TASKVISIBLE',
                        data: false
                    });
                    dispatch({
                        type: 'SET_CALENDARLABLE',
                        data: { ...res.data, content: store.myEditMemo?.data?.content, }
                    });
                    props.onRefresh && props.onRefresh()
                }
            }
            if (store.selectTagMeta.name == '图片格式') {

                let res: any = await apis.putMemoImageTag(memo.data.id, {
                    title: form.getFieldsValue().title,
                    imagePath: imgId
                })
                if (res.ok) {
                    dispatch({
                        type: 'SET_TASKVISIBLE',
                        data: false
                    });
                    setIsDeletExecutor(false)
                    setImgId('')
                    props.onRefresh && props.onRefresh()
                }
            }
            if (store.selectTagMeta.name == '图片标注') {
                console.log(memo.data.id)
                let _annotation: any = []
                console.log('imageOverlaysMarkData', imageOverlaysMarkData)
                store.ImgNotesTag.map((i: any, index: any) => {
                    _annotation.push({
                        "x": imageOverlaysMarkData[index]?.coor[0][0],
                        "y": imageOverlaysMarkData[index]?.coor[0][1],
                        "w": imageOverlaysMarkData[index]?.coor[1][0],
                        "h": imageOverlaysMarkData[index]?.coor[1][1],
                        "description": i.description,
                    })
                })
                let res: any = await apis.putMemoImgNotesTag(memo.data.id, {
                    annotation: _annotation,
                    imagePath: imgId,
                    title: form.getFieldsValue().title,
                })
                if (res.ok && !imgNotesTagNextStep) {
                    dispatch({
                        type: 'SET_TASKVISIBLE',
                        data: false
                    });
                    setIsDeletExecutor(false)
                    setImgId('')
                    props.onRefresh && props.onRefresh()
                }
            }
            if (store.selectTagMeta.name == '版本计划') {
                let res: any = await apis.putMemoRelease(memo.data.id, {
                    memoId: memo.data.id,
                    release: form.getFieldsValue().release
                })
                if (res.ok) {
                    dispatch({
                        type: 'SET_TASKVISIBLE',
                        data: false
                    });
                    setIsDeletExecutor(false)
                    props.onRefresh && props.onRefresh()
                }
            }
            // dispatch({
            //     type: 'SET_MEMOINFO',
            //     data: { ...store.memoInfo, content: title, data: { ...store.memoInfo.data, content: title, } }
            // });
        } catch (e) {
            console.log(e)
        }
    }
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date, dateString);
        if (!date) {
            form.resetFields(['finishTime'])
        }
        setFinishTime(dateString)
    };
    return (
        <><div data-flex="main:justify cross:center" className='mb-10'>
            <ModelScreen name={store.selectTagMeta.name} />
            <div className='mr-20'>
                {imgNotesTagNextStep ?
                    <div data-flex='main:right' className=' '>
                        <Button className='btn_dark btn'
                            onClick={async () => {
                                console.log('下一步', store.myEditMemo)
                                if (imgId) {
                                    setImgNotesTagNextStep(false)
                                    if (!store.memoOperation.isAdd) {
                                        addTask()
                                    } else {
                                        setTitle(form.getFieldsValue().title)
                                    }
                                    let ImgNotesTag: any = store.myEditMemo.data.tagMetas?.filter((i: any) => i.notation === 'ImgNotesTag')
                                    console.log('store.myEditMemo', store.myEditMemo)
                                    if (ImgNotesTag && ImgNotesTag.length > 0) {
                                        console.log(ImgNotesTag[0].instance.imagePath, imgId)
                                        if (ImgNotesTag[0].instance.imagePath != imgId) {
                                            store.ImgNotesTag.map((i: any, index: any) => {
                                                (document as any).getElementById('imgOver')?.removeChild(document.getElementById(`tagging${i.id}`))
                                            })
                                            dispatch({
                                                type: 'SET_IMGNOTESTAG',
                                                data: []
                                            });
                                        }
                                    }
                                } else {
                                    // form.validateFields()
                                    message.warning('请上传图片')
                                }
                            }}
                        >下一步</Button></div> :
                    <div data-flex='main:right' className=' '>
                        {store.selectTagMeta.name === '图片标注' && <Button className='btn_dark btn mr-10'
                            onClick={() => {
                                setImgNotesTagNextStep(true)
                            }}
                        >上一步</Button>}
                        <Button className='btn_dark btn' onClick={() => {
                            if (store.selectTagMeta.name?.indexOf('图片') > -1) {
                                if (!form.getFieldsValue().title && !title && !store.myEditMemo.data.content) {
                                    message.warning('请填写标题或说明文字')
                                    return
                                }
                                if (!imgId) {
                                    message.warning('请上传图片')
                                    return
                                }
                                if (store.selectTagMeta?.mimeType == 'image/m2ni-img-notas' && store.ImgNotesTag.length == 0) {
                                    message.warning('请增加标注')
                                    return
                                }
                            }
                            if (store.memoOperation.isAdd && store.selectTagMeta.name?.indexOf('图片') > -1) {
                                props.saveNode && props.saveNode(store.selectTagMeta?.mimeType, title)
                                props.onClose && props.onClose()
                            } else {
                                addTask(); props.onClose && props.onClose()
                            }
                        }}>{store.selectTagMeta.name?.indexOf('图片') > -1 ? '保存' : '确认'}</Button>
                    </div>
                }</div>
        </div>
            <div>
                <Form

                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ manHour: taskInfo?.manHour || 1, finishTime: moment(today) }}
                    onFinish={() => {
                        addTask()
                    }}
                    onFinishFailed={() => {
                        console.log()
                    }}
                    autoComplete="off"
                    form={form}
                >

                    {(store.selectTagMeta.name === '任务计划' || store.selectTagMeta.name == '开始执行' || store.selectTagMeta.name == '任务完成') && <>
                        <Form.Item
                            label='执行人'
                            name="executorId"
                        // rules={[{ required: (store.selectTagMeta.name === '任务计划') ? true : false, message: `请输入执行人!` }]}
                        >
                            {store.selectTagMeta.name == '任务计划' && <>
                                <>{console.log(form.getFieldsValue().executorId, executorInfo)}</>
                                {
                                    form.getFieldsValue().executorId && !isDeletExecutor ? <>
                                        <img alt="" onClick={() => {
                                            setUsersVisible(true)
                                        }} style={{ width: '30px', height: '30px' }} src={(executorInfo?.avatar) ? getImgUrlById(executorInfo?.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                        <span className={'ml-10 '}>{executorInfo?.username}</span> <CloseCircleOutlined className={'ml-10 mt-10 icon_hover'} onClick={() => {
                                            setIsDeletExecutor(true)
                                            form.setFieldsValue({
                                                executorId: null
                                            });
                                        }} />
                                    </> : <PlusCircleOutlined onClick={() => {
                                        setUsersVisible(true)
                                        setIsDeletExecutor(false)
                                    }} />
                                }</>}
                            {(store.selectTagMeta.name == '开始执行' || store.selectTagMeta.name == '任务完成') && <>
                                <>{console.log(executorInfo, userInfo)}</>
                                {executorInfo?.avatar ? <><img alt="" onClick={() => {
                                }} style={{ width: '30px', height: '30px' }} src={(executorInfo?.avatar) ? getImgUrlById(executorInfo?.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                    <span className={'ml-10 '}>{executorInfo?.username}</span>
                                </> : <><img alt="" onClick={() => {
                                }} style={{ width: '30px', height: '30px' }} src={(userInfo?.avatar) ? getImgUrlById(userInfo?.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                    <span className={'ml-10 '}>{userInfo?.username}</span>
                                </>
                                }
                            </>}
                        </Form.Item>
                        <Form.Item
                            label={store.selectTagMeta.label1}
                            name="finishTime"
                            initialValue={taskInfo?.finishTime}
                            rules={[{ required: true, message: `请输入${store.selectTagMeta.label1}!` }]}
                        >
                            <DatePicker defaultPickerValue={moment(today)} onPanelChange={(value, mode) => {
                                console.log(value, mode)
                            }} onChange={onChange} allowClear={false} format="YYYY-MM-DD" />
                        </Form.Item>
                        <Form.Item
                            label={store.selectTagMeta.label2}
                            name="manHour"
                            initialValue={taskInfo?.manHour}
                            rules={[{ required: true, message: `请输入${store.selectTagMeta.label2}!` }
                                , {
                                validator: (rule, val, callback) => {
                                    if (!val) {
                                        callback();
                                    }
                                    let reg = new RegExp(/^[0-9]\d*$/, "g")
                                    if (!reg.test(val)) {
                                        callback('请输入正整数！');
                                    } else if (val < 1) {
                                        // callback('此数值大于等于1')
                                    } else if (val > 10) {
                                        // callback('此数值小于等于10')
                                    }
                                    callback();

                                }
                            }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </>
                    }
                    {
                        (store.selectTagMeta.name == '版本计划') &&
                        <Form.Item
                            label='版本号'
                            name="release"
                            rules={[{ required: true, message: '请输入版本号!' }]}
                        >
                            <Input />
                        </Form.Item>
                    }
                    {
                        (store.selectTagMeta.name == '图片格式') &&
                        <>
                            <Form.Item
                                label=''
                                name="imagePath"
                                data-flex='main:center cross:center'
                                rules={[{ required: true, message: '请上传图片!' }]}
                            >
                                {imgId &&
                                    <div className='pos-r'>
                                        <CloseCircleOutlined className={`${style.imgClose} icon_hover`}
                                            onClick={() => {
                                                setImgId('')
                                                form.setFieldsValue({
                                                    imagePath: null
                                                });
                                                //便签无内容时，上传图片，图片说明未自动填充图片名称,且清除时直接将title清除
                                                if (!taskInfo.title) {
                                                    form.setFieldsValue({
                                                        title: ''
                                                    });
                                                }
                                            }} />
                                        {/* {imgId&& <div  style={{width:'100px',height:'100px'}}   dangerouslySetInnerHTML={{ __html: fetchSvg(imgId) }} />} */}
                                        <div className={style.img} style={{ backgroundImage: `url(${getImgUrlById(imgId)})` }}>
                                        </div>
                                    </div>
                                }
                                {!imgId &&
                                    <InitUpload onRefresh={(id, file) => {
                                        if (!form.getFieldsValue().title) {
                                            form.setFieldsValue({
                                                title: file.name
                                            });
                                            setTitle(file.name)
                                        }
                                        setImgId(id);
                                        form.setFieldsValue({
                                            imagePath: id
                                        });
                                    }} type='tuozhai' />
                                }
                            </Form.Item>
                            <Form.Item
                                label=''
                                name="title"
                                data-flex='main:center cross:center'
                            // rules={[{ required: true, message: '请填写标题或说明文字!' }]}
                            >
                                <TextArea placeholder='请填写标题或说明文字' onChange={e => setTitle(e.target.value)} />

                            </Form.Item>
                        </>
                    }
                    {
                        (store.selectTagMeta.name == '图片标注') &&
                        <>
                            <>{console.log(form.getFieldsValue().imagePath, imgId)}</>
                            {
                                imgNotesTagNextStep ?
                                    <>
                                        <Form.Item
                                            label=''
                                            name="imagePath"
                                            data-flex='main:center cross:center'
                                            rules={[{ required: true, message: '请上传图片!' }]}
                                        >
                                            {imgId &&
                                                <div className='pos-r'>
                                                    <CloseCircleOutlined className={`${style.imgClose} icon_hover`}
                                                        onClick={() => {
                                                            setImgId('')
                                                            form.setFieldsValue({
                                                                imagePath: null
                                                            });
                                                            //便签无内容时，上传图片，图片说明未自动填充图片名称,且清除时直接将title清除
                                                            if (!taskInfo.title) {
                                                                form.setFieldsValue({
                                                                    title: ''
                                                                });
                                                            }
                                                        }} />
                                                    <div className={style.img} style={{ backgroundImage: `url(${getImgUrlById(imgId)})` }}>
                                                    </div>
                                                </div>
                                            }
                                            {!imgId &&
                                                <InitUpload onRefresh={(id, file) => {
                                                    if (!form.getFieldsValue().title) {
                                                        form.setFieldsValue({
                                                            title: file.name
                                                        });
                                                        setTitle(file.name)
                                                    }
                                                    setImgId(id);
                                                    form.setFieldsValue({
                                                        imagePath: id
                                                    });
                                                }} type='tuozhai' />
                                            }
                                        </Form.Item>
                                        <Form.Item
                                            label=''
                                            name="title"
                                            data-flex='main:center cross:center'
                                        // rules={[{ required: true, message: '请填写标题或说明文字!' }]}
                                        >
                                            <TextArea placeholder='请填写标题或说明文字。' onChange={e => setTitle(e.target.value)} />
                                        </Form.Item></> : <>
                                        <ImageOverlays imgId={imgId} onChange={(e) => {
                                            console.log('ImageOverlays', e)
                                            setImageOverlaysMarkData(e)
                                            // setAnnotation(e)
                                        }} />
                                    </>
                            }

                        </>

                    }

                </Form>
            </div>
            <Users title={'选择执行人'} visible={usersVisible} onList={userList} onRefresh={(e, row) => { form.setFieldsValue({ executorId: e }); setExecutorInfo(row); setUsersVisible(false) }} onClose={() => { setUsersVisible(false); }} />
        </>
    )
}

export default TaskTagPop